<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue-next';
import ItpIcon from '../icon/ItpIcon.vue';

interface LocaleSpec {
  code: string;
  name: string;
}

const instance = getCurrentInstance();
const proxy = instance?.proxy as any;
const root = proxy?.$root;
const $app = computed(() => root?.$app);

const currentLocale = computed<LocaleSpec | undefined>(() => {
  const locales = $app.value?.i18n?.getLocales() || [];
  const currentCode = $app.value?.i18n?.locale;
  return locales.find((loc: LocaleSpec) => loc.code === currentCode);
});

const localesInDropdown = computed<LocaleSpec[]>(() => {
  const locales = $app.value?.i18n?.getLocales() || [];
  const current = currentLocale.value;
  if (!current) {
    return locales;
  }
  return locales.filter((loc: LocaleSpec) => loc.code !== current.code);
});

function setLocale(locale: LocaleSpec) {
  $app.value?.i18n?.setLocale(locale.code);
}
</script>

<template>
  <BNavItemDropdown right>
    <template #button-content>
      <ItpIcon name="fa-flag" class="me-1" />
      <em>{{ currentLocale?.code }}</em>
    </template>

    <BDropdownItem
      v-for="locale in localesInDropdown"
      :key="locale.code"
      href="#"
      @click="setLocale(locale)"
    >
      {{ locale.name }} ({{ locale.code }})
    </BDropdownItem>
  </BNavItemDropdown>
</template>

